import React from "react";

export default function CSS_Syllabus() {
  return (
    <div className="tutorial-page">
      <h1>CSS Syllabus</h1>
      <p>This is the CSS Syllabus tutorial page.</p>
    </div>
  );
}
